import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../shared/contexts/authContext";

// ProtectedRoute 컴포넌트 정의
export const ProtectedRoute = ({ children }) => {
    const { currentUser } = useContext(AuthContext);

    if (!currentUser) {
        return <Navigate to="/login" />;
    }
    return children;
};
